import { gql } from '@apollo/client';

const LEVEL_ENTRY_FIELDS = gql`
  fragment UserLevelConfigEntryFields on UserLevelConfigEntry {
    level
    xpToNextLevel
    basicReward
    plusReward
    unlockedFeatures
    source
  }
`;

export const GET_USER_LEVEL_CONFIG = gql`
  ${LEVEL_ENTRY_FIELDS}
  query getUserLevelConfig {
    liveOps {
      userLevelConfig {
        ...UserLevelConfigEntryFields
      }
      userLevelConfigFeatures
    }
  }
`;

export const UPSERT_LEVEL_OVERRIDE = gql`
  ${LEVEL_ENTRY_FIELDS}
  mutation upsertUserLevelConfigOverride($input: UserLevelConfigOverrideInput!) {
    upsertUserLevelConfigOverride(input: $input) {
      ...UserLevelConfigEntryFields
    }
  }
`;

export const DELETE_LEVEL_OVERRIDE = gql`
  mutation deleteUserLevelConfigOverride($level: Int!) {
    deleteUserLevelConfigOverride(level: $level)
  }
`;
